<!-- eslint-disable max-len -->
<template>
  <div>
    <!-- Type icon -->
    <div class="type-icon">
      <img
        v-if="dataDetail.trigger.type === 'form'"
        :src="require('@/assets/automation/data_manager.svg')"
        width="62"
        height="62"
      >
      <img
        v-else-if="dataDetail.trigger.type === 'event'"
        :src="require('@/assets/automation/event.svg')"
        width="62"
        height="62"
      >
      <img
        v-else-if="dataDetail.trigger.type === 'function'"
        :src="require('@/assets/automation/function.svg')"
        width="62"
        height="62"
      >
      <img
        v-else-if="dataDetail.trigger.type === 'job' ||
        dataDetail.trigger.type === 'dedicated_job'"
        :src="require('@/assets/automation/job.svg')"
        width="62"
        height="62"
      >
      <img
        v-else
        :src="require('@/assets/automation/api.svg')"
        width="62"
        height="62"
      >
    </div>

    <!-- Button open -->
    <button
      type="button"
      class="btn-open-tab"
      @click="handleOpenNewTab"
    >
      <img
        src="@/assets/icon/foldering/open.svg"
        width="16"
        height="16"
        alt="open-tab-icon"
      >
      Open
    </button>

    <!-- Access Section -->
    <section>
      <p class="title-section">Who Has Access</p>

      <div class="d-flex">
        <!-- If have profile pic -->
        <img
          v-if="profile_data && profile_data.photo_url"
          :src="profile_data.photo_url"
          width="42"
          height="42"
          alt="profile-pic-access"
          class="profile-pic-access"
        >

        <!-- Create initial name if dont have initial name -->
        <div
          v-else
          :style="`background-color: ${bg_initial_profile}`"
          class="initial-access"
        >
          {{ initialName }}
        </div>

        <div class="access-name">Anyone</div>
      </div>
    </section>

    <!-- Properties Section -->
    <section>
      <p class="title-section">System Properties</p>

      <!-- Type -->
      <div class="list-properties">
        <p class="properties-title">Type</p>
        <p class="properties-detail">
          {{ propertiesType }}
          <span v-html="propertiesEvent" />
        </p>
      </div>

      <!-- Source -->
      <div class="list-properties">
        <p class="properties-title">{{ sourceTitle }}</p>
        <div
          v-if="dataDetail.trigger.type === 'form'"
          class="d-flex flex-wrap align-items-center properties-source"
        >
          <span
            v-if="tableGroupname"
            style="text-transform: lowercase;"
          >
            {{ tableGroupname }}
          </span>
          <span
            v-else
            class="skeleton-desc"
          />
          <i class="fa fa-caret-right mx-2 caret-icon"/>
          {{ propertiesSource }}
        </div>
        <div
          v-else
          :class="{'properties-url': dataDetail.trigger.type.includes('api') || dataDetail.trigger.type.includes('webhook')}"
          class="properties-source"
        >
          {{ propertiesSource }}
          <i
            v-if="propertiesSource && (dataDetail.trigger.type.includes('api') || dataDetail.trigger.type.includes('webhook'))"
            class="fa fa-clone clone-icon"
            @click="copyToClipboard"
          />
        </div>
      </div>

      <!-- Status -->
      <div class="list-properties">
        <p class="properties-title">Status</p>
        <div
          :class="dataDetail.is_active ? 'status-on' : 'status-off'"
          class="status"
        >
          <div class="circle-accent" />
          <span>{{ dataDetail.is_active ? 'ON' : 'OFF' }}</span>
        </div>
      </div>

      <!-- Description -->
      <div class="list-properties">
        <p class="properties-title">Description</p>
        <p class="properties-desc">{{ dataDetail.description || '-' }}</p>
      </div>

      <!-- Location -->
      <div class="list-properties">
        <p class="properties-title">Location</p>
        <p class="properties-detail">Visual Programming</p>
      </div>

      <!-- Owner -->
      <div class="list-properties">
        <p class="properties-title">Owner</p>
        <p class="properties-detail">Me</p>
      </div>

      <!-- Modified By -->
      <div class="list-properties">
        <p class="properties-title">Modified By</p>
        <div class="created-by">
          <img
            v-if="dataDetail.updated_by_person.photo"
            :src="dataDetail.updated_by_person.photo"
            rounded="circle"
            alt="img"
            class="round-bordered-img"
          >
          <img
            v-else
            src="@/assets/logo/user1.png"
            alt="img"
            class="round-bordered-img"
          >
          <div>
            <div class="email">{{ dataDetail.updated_by_person.email }}</div>
            <div class="name">{{ dataDetail.updated_by_person.first_name }} {{ dataDetail.updated_by_person.last_name }}</div>
          </div>
        </div>
      </div>

      <!-- Modified -->
      <div class="list-properties">
        <p class="properties-title">Modified at</p>
        <p class="properties-detail">{{ convertDateTime(dataDetail.updated_at) }}</p>
      </div>

      <!-- Created By -->
      <div class="list-properties">
        <p class="properties-title">Created By</p>
        <div class="created-by">
          <img
            v-if="dataDetail.created_by_person.photo"
            :src="dataDetail.created_by_person.photo"
            rounded="circle"
            alt="img"
            class="round-bordered-img"
          >
          <img
            v-else
            src="@/assets/logo/user1.png"
            alt="img"
            class="round-bordered-img"
          >
          <div>
            <div class="email">{{ dataDetail.created_by_person.email }}</div>
            <div class="name">{{ dataDetail.created_by_person.first_name }} {{ dataDetail.created_by_person.last_name }}</div>
          </div>
        </div>
      </div>

      <!-- Created -->
      <div class="list-properties">
        <p class="properties-title">Created at</p>
        <p class="properties-detail">{{ convertDateTime(dataDetail.created_at) }}</p>
      </div>
    </section>
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode';
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    dataDetail: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      firstLoad: true,
      tableGroupname: '',
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },

  computed: {
    ...mapState('jStoreLogin', ['profile_data', 'bg_initial_profile']),

    // eslint-disable-next-line consistent-return
    fullName() {
      if (this.profile_data) {
        return `${this.profile_data.first_name} ${this.profile_data.last_name}`;
      }
    },

    // eslint-disable-next-line consistent-return
    initialName() {
      if (this.profile_data) {
        return this.createInitialName(this.fullName);
      }
    },

    propertiesType() {
      let type = '';
      if (this.dataDetail.trigger) {
        switch (this.dataDetail.trigger.type) {
          case 'form':
            type = 'Data Manager';
            break;
          case 'api':
            type = 'API';
            break;
          case 'api_v2':
            type = 'API';
            break;
          case 'webhook':
            type = 'Webhook';
            break;
          case 'webhook_v2':
            type = 'Webhook';
            break;
          case 'event':
            type = 'Event';
            break;
          case 'function':
            type = 'Function';
            break;
          case 'job':
            type = 'Job';
            break;
          case 'dedicated_job':
            type = 'Dedicated Job';
            break;
          default :
            type = '-';
        }
      }
      return type;
    },

    propertiesEvent() {
      let event = '';
      if (this.dataDetail.trigger) {
        switch (this.dataDetail.trigger.type) {
          case 'form':
            event = this.dataDetail.trigger.form ? `- ${this.dataDetail.trigger.form.event.replace('_', ' ')}` : '';
            break;
          case 'api':
            event = this.dataDetail.trigger.api ? `- <b>${this.dataDetail.trigger.api.method.toUpperCase()}</b>` : '';
            break;
          case 'api_v2':
            event = this.dataDetail.trigger.api_v2 ? `- <b>${this.dataDetail.trigger.api_v2.method.toUpperCase()}</b>` : '';
            break;
          case 'webhook':
            event = this.dataDetail.trigger.webhook ? `- <b>${this.dataDetail.trigger.webhook.method.toUpperCase()}</b>` : '';
            break;
          case 'webhook_v2':
            event = this.dataDetail.trigger.webhook_v2 ? `- <b>${this.dataDetail.trigger.webhook_v2.method.toUpperCase()}</b>` : '';
            break;
          default :
            event = '';
        }
      }
      return event;
    },

    propertiesSource() {
      let source = '';
      if (this.dataDetail.trigger) {
        switch (this.dataDetail.trigger.type) {
          case 'form':
            source = this.dataDetail.trigger.form ? this.dataDetail.trigger.form.form_data_name : '';
            break;
          case 'api':
            source = this.dataDetail.trigger.api ? `${this.baseURL}/${this.dataDetail.trigger.api.url}` : '';
            break;
          case 'api_v2':
            source = this.dataDetail.trigger.api_v2 ? `${this.baseURL}/${this.dataDetail.trigger.api_v2.url}` : '';
            break;
          case 'webhook':
            source = this.dataDetail.trigger.webhook ? `${this.baseURL}/${this.dataDetail.trigger.webhook.url}` : '';
            break;
          case 'webhook_v2':
            source = this.dataDetail.trigger.webhook_v2 ? `${this.baseURL}/${this.dataDetail.trigger.webhook_v2.url}` : '';
            break;
          case 'function':
            source = this.dataDetail.trigger.function ? this.dataDetail.trigger.function.name : '';
            break;
          case 'job':
            source = this.dataDetail.trigger.job ? this.dataDetail.trigger.job.name : '';
            break;
          case 'dedicated_job':
            source = this.dataDetail.trigger.dedicated_job ? this.dataDetail.trigger.dedicated_job.name : '';
            break;
          default :
            source = '';
        }
      }
      return source;
    },

    sourceTitle() {
      let type = '';
      if (this.dataDetail.trigger) {
        switch (this.dataDetail.trigger.type) {
          case 'form':
            type = 'Database';
            break;
          case 'api':
            type = 'URL';
            break;
          case 'api_v2':
            type = 'URL';
            break;
          case 'webhook':
            type = 'URL';
            break;
          case 'webhook_v2':
            type = 'URL';
            break;
          case 'event':
            type = 'Event Name';
            break;
          case 'function':
            type = 'Function Name';
            break;
          case 'job':
            type = 'Job Name';
            break;
          case 'dedicated_job':
            type = 'Job Name';
            break;
          default :
            type = '-';
        }
      }
      return type;
    },

    // Base url for API or Webhook
    baseURL() {
      if (this.dataDetail && this.dataDetail.trigger) {
        const type = this.dataDetail.trigger.type;

        if (type === 'api_v2') return `${process.env.URL_API_V2}${this.session.user.company_id}`;
        else if (type === 'webhook_v2') return `${process.env.URL_WEBHOOK_V2}${this.session.user.company_id}`;
        return `${process.env.GATE_URL}nocode/${type}`;
      }
      return '';
    },
  },

  watch: {
    dataDetail(val) {
      if (val.trigger.type === 'form' && !this.firstLoad) this.getTableGroupName();
    },
  },

  mounted() {
    if (this.dataDetail.trigger.type === 'form' && this.firstLoad) {
      this.getTableGroupName();
    }
    this.firstLoad = false;
  },

  methods: {
    ...mapActions('jStoreForm', ['getListDataGroupByCompanyId']),

    createInitialName(name) {
      return name.match(/(\b\S)?/g).join('').match(/(^\S|\S$)?/g).join('')
        .toUpperCase();
    },

    getTableGroupName() {
      this.tableGroupname = '';
      const params = {
        limit: 1,
        search: this.dataDetail.trigger.form.tablegroup_id,
      };
      this.getListDataGroupByCompanyId(params).then((res) => {
        if (!res.error) this.tableGroupname = res.data[0].name;
      });
    },

    convertDateTime(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

        return `${dates}/${month}/${years} ${hours}:${minutes}`;
      }
      return null;
    },

    handleOpenNewTab() {
      const url = `${window.location.origin}/#/visual-programming/${this.dataDetail.id}`;
      window.open(url, '_blank');
    },

    // Copy to clipboard
    copyToClipboard() {
      const el = document.createElement('textarea');
      el.value = this.propertiesSource;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.$store.dispatch('jStoreNotificationScreen/toggleSuccess', 'Copied to clipboard');
    },
  },
};
</script>

<style lang="scss" scoped>
.type-icon {
  width: 100%;
  height: 136px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid $gray-border;
}

.btn-open-tab {
  width: 100%;
  background-color: white;
  padding: 10px 20px;
  border: none;
  @include font('Poppins-Regular', 12px, $black);
  box-shadow: 0px 0px 29px 0px #78787830;
  margin-top: 10px;
  margin-bottom: 20px;

  img {
    margin-right: 5px;
  }
}

section {
  margin-bottom: 30px;

  &:last-child {
    margin-bottom: 0px;
  }

  .title-section {
    @include font('Poppins-Semibold', 14px, $black);
    margin-bottom: 10px;
  }

  .list-properties {
    margin-bottom: 18px;

    &:last-child {
      margin-bottom: 0px;
    }

    .properties-title {
      @include font('Poppins-Regular', 11px, $black);
      margin-bottom: 3px;
    }

    .properties-detail {
      @include font('Poppins-Medium', 12px, $black);
      line-height: 20px;
      margin-bottom: 0px;
      word-break: break-word;

      span {
        @include font('Poppins-Medium', 12px, $black);
        word-break: break-word;
        text-transform: capitalize;
      }
    }

    .properties-source {
      position: relative;
      width: 100%;
      min-height: 29px;
      @include font('Poppins-Medium', 12px, $black);
      line-height: 20px;
      margin-bottom: 0px;
      word-break: break-word;
      padding: 4px;
      border: 1px solid $gray-border;
      border-radius: 2px;

      &.properties-url {
        padding: 4px 26px 4px 4px;
      }

      span {
        @include font('Poppins-Medium', 12px, $black);
        word-break: break-word;
        text-transform: capitalize;
      }

      .caret-icon {
        color: $black;
        cursor: pointer;
      }

      .clone-icon {
        position: absolute;
        top: 8px;
        right: 4px;
        color: $black;
        cursor: pointer;
      }
    }

    .properties-desc {
      width: 100%;
      @include font('Poppins-Medium', 11px, $black);
      padding: 4px;
      border: 1px solid $gray-border;
      border-radius: 2px;
    }

    .skeleton-desc {
      display: block;
      width: 80px;
      height: 20px;
      background-color: #F4F4F4;
      border-radius: 2px;
      animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    }

    @keyframes pulse {
      50% {
        opacity: .5;
      }
    }
  }
}

.profile-pic-access {
  border-radius: 9999px;
  object-fit: cover;
}

.initial-access {
  width: 42px;
  min-width: 42px;
  max-width: 42px;
  height: 42px;
  min-height: 42px;
  max-height: 42px;
  border-radius: 9999px;
  border-width: 2px;
  border-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 14px;
}

.access-name {
  display: flex;
  align-items: center;
  height: 42px;
  @include font('Poppins-Regular', 12px, $gray-1);
  margin-left: 10px;
  padding-left: 10px;
  border-left: 1px solid $gray-border;
}

.status {
  width: min-content;
  display: flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 9999px;

  .circle-accent {
    width: 12px;
    height: 12px;
    margin-right: 4px;
    border-radius: 9999px;
  }
  span {
    @include font('Poppins-Semibold', 12px, $black);
  }

  &.status-on {
    background-color: #F0F8E5;

    .circle-accent {
      background-color: #61BC50;
    }
    span {
      color: #61BC50;
    }
  }
  &.status-off {
    background-color: #FFEBED;

    .circle-accent {
      background-color: #D0021B;
    }
    span {
      color: #D0021B;
    }
  }
}

.created-by {
  display: flex;
  align-items: center;

  img {
    margin-right: 5px;
  }
  .email {
    @include font('Poppins-Regular', 10px, $black-2);
    margin-bottom: 1px;
  }

  .name {
    @include font('Poppins-Regular', 12px, $black-2);
    margin-bottom: 0;
  }
}

.round-bordered-img {
  border-radius: 100%;
  width: 40px;
  height: 40px;
  background-size: 40px;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/views/visual-programming/popup/partials/jPopupDetailTab.vue